import { useEffect } from "react";

const dirty = new Set();
const MSG = "You have unsaved changes. Leave without saving?";

export const same = (a, b) => JSON.stringify(a) === JSON.stringify(b);

export function useUnsaved(isDirty) {
  useEffect(() => {
    if (!isDirty) return undefined;
    const id = Symbol("unsaved");
    dirty.add(id);
    return () => { dirty.delete(id); };
  }, [isDirty]);
}

export function UnsavedGuard() {
  useEffect(() => {
    const onUnload = (e) => { if (dirty.size) { e.preventDefault(); e.returnValue = MSG; } };
    const onClick = (e) => {
      if (!dirty.size || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      const a = e.target.closest?.("a[href]");
      if (!a || a.target === "_blank" || a.origin !== window.location.origin) return;
      if (a.pathname === window.location.pathname && a.search === window.location.search) return;
      if (!window.confirm(MSG)) { e.preventDefault(); e.stopPropagation(); return; }
      dirty.clear();
    };
    window.addEventListener("beforeunload", onUnload);
    document.addEventListener("click", onClick, true);
    return () => { window.removeEventListener("beforeunload", onUnload); document.removeEventListener("click", onClick, true); };
  }, []);
  return null;
}

export const UnsavedBadge = ({ show, dark = false }) => (show
  ? <span className={`inline-flex items-center gap-1.5 text-xs font-semibold ${dark ? "text-amber-200" : "text-amber-700"}`} data-testid="unsaved-badge"><span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />Unsaved changes</span>
  : null);
